import * as React from 'react'

// Fill-only, no strokes, and one path — the same shape every other icon here
// takes. `Icon` colours a glyph with `[&_svg_path]:fill-current`, which as a
// class beats a `stroke` presentation attribute and would fill a stroked
// outline solid, so the frame is drawn as an even-odd ring instead: the outer
// and inner rounded rectangles cancel to leave the border, and the divider and
// day marks sit inside that hole with an odd crossing count, so they fill.
const SvgCalendarOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M6 5h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 1.5h12A1.5 1.5 0 0 1 19.5 8v10a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18V8A1.5 1.5 0 0 1 6 6.5M4.5 9.5h15V11h-15zm3.5 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCalendarOutlined
